module.exports = __webpack_public_path__ + "a0d0a44d04cf55d03c74aadd90a7414f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-ja.html
// module id = 980
// module chunks = 0